import "core-js/stable";
import "regenerator-runtime/runtime";

import Vue from 'vue'

import './assets/style.scss'
import App from './App.vue'
import router from './router'




// Components
import Pageheader from './components/Pageheader.vue'
Vue.component('pageheader', Pageheader);

import VueBarcode from 'vue-barcode';
Vue.component('barcode', VueBarcode);

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import JsonCSV from 'vue-json-csv'
Vue.component('downloadCsv', JsonCSV) // CSV downloader




Vue.prototype.$git = GIT_DESCRIBE;


import './plugins/bootstrap-vue'
import './plugins/fontawesome'

Vue.config.productionTip = process.env.NODE_ENV === 'development'


import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';

// STORE
import store from '@/store'

if (localStorage.hasOwnProperty("state")) {
    store.state = JSON.parse(localStorage.state);
}
else {
    localStorage.state = JSON.stringify(store.state);
}

Vue.prototype.$store = store;


// API - Axios / Https config
import axios from 'axios'
Vue.prototype.$http = axios

const teknobingoApi = axios.create({
    baseURL: process.env.VUE_APP_API_URL
})
Vue.prototype.$api = teknobingoApi


if (store.state.token) teknobingoApi.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.token;


// AUTH
// Throw out users without auth on new data fetch
teknobingoApi.interceptors.response.use(
    (response) => {
        return response;
    }, (error) => {
        if (error.response && error.response.status == 401) {
            store.clear();
            // ["/logginn", "/meldinn"].contains(router.currentRoute.path)
            if (router.currentRoute.meta.auth) router.replace('/logginn');
        }

        return Promise.reject(error);
    }
);

// Throw out users without auth on refresh
teknobingoApi.get('/ping')
    .catch((response) => { });

// Router auth check
router.beforeEach((to, from, next) => {

    if (to.matched.some(record => record.meta.auth)) {
        if (!store.state.user) {
            next({
                path: '/logginn',
                params: { nextUrl: to.fullPath }
            })
        }
        else {
            next()
        }
    }
    else if (to.matched.some(record => record.meta.guest)) {
        if (store.state.user) {
            next({
                path: '/'
            })
        }
        else {
            next()
        }
    }
    else {
        next()
    }
})


// Helpers
import helpers from './helpers'


Vue.mixin({
    methods: {
        showNotification(title, content, variant = 'success') {
            this.$bvToast.toast(content, {
                title: title,
                autoHideDelay: 3000,
                appendToast: true,
                variant: variant
            })
        },
        formatDatetime: helpers.formatDatetime,
        formatShortDatetime: helpers.formatShortDatetime,
        formatDate: helpers.formatDate,
        formatTime: helpers.formatTime
    }
});


Vue.filter('formatDatetime', function(value) {
    return helpers.formatDatetime(value)
})
Vue.filter('formatDate', function(value) {
    return helpers.formatDate(value)
})



new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
